import { Colors } from '@hawkins/variables';
import { Coordinates, TriangleResolution } from '../types';
import { Resolution } from 'src/domains/calculators/utilities/types';
import { drawTriangles } from './FramingChartTriangles';

export function drawSensorArea(
  ctx: CanvasRenderingContext2D,
  canvasResolution: Resolution,
  triangleResolution: TriangleResolution
): void {
  ctx.fillStyle = Colors.Gray700;
  const { width, height } = canvasResolution;

  ctx.fillRect(0, 0, width, height);
  drawTriangles(ctx, triangleResolution, 0, 0, width, height, Colors.White);
}

export function drawEffectiveCanvas(
  ctx: CanvasRenderingContext2D,
  effectiveCanvasResolution: Resolution,
  effectiveCanvasCoordinates: Coordinates,
  triangleResolution: TriangleResolution
): void {
  // Colors.Gray600 is too similar to Gray700 (bg of the sensor area),
  // so we are using a custom RGB color for better contrast.
  ctx.fillStyle = 'rgb(75, 75, 75)';
  ctx.fillRect(
    effectiveCanvasCoordinates.x,
    effectiveCanvasCoordinates.y,
    effectiveCanvasResolution.width,
    effectiveCanvasResolution.height
  );

  drawTriangles(
    ctx,
    triangleResolution,
    effectiveCanvasCoordinates.x,
    effectiveCanvasCoordinates.y,
    effectiveCanvasResolution.width,
    effectiveCanvasResolution.height,
    Colors.Gray700
  );
}

export function drawFramingDecisionProtectionArea(
  ctx: CanvasRenderingContext2D,
  framingDecisionProtectionResolution: Resolution,
  framingDecisionProtectionCoordinates: Coordinates,
  triangleResolution: TriangleResolution
): void {
  ctx.fillStyle = Colors.Gray500;
  const { width, height } = framingDecisionProtectionResolution;
  const { x, y } = framingDecisionProtectionCoordinates;

  ctx.fillRect(x, y, width, height);

  drawTriangles(ctx, triangleResolution, x, y, width, height, Colors.Gray600);
}

export function drawFramingDecisionArea(
  ctx: CanvasRenderingContext2D,
  framingDecisionResolution: Resolution,
  framingDecisionCoordinates: Coordinates,
  triangleResolution: TriangleResolution
): void {
  const { width, height } = framingDecisionResolution;
  const { x, y } = framingDecisionCoordinates;

  ctx.fillStyle = Colors.Gray400;
  ctx.fillRect(x, y, width, height);

  drawTriangles(ctx, triangleResolution, x, y, width, height, Colors.Red700);
}
